module.exports = "<div class=\"col-xs-12\">\r\n  <ul *ngFor=\"let labTest of labTests\">\r\n    <li>{{labTest.labTestName}}</li>\r\n  </ul>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/waiting-room/group-template/group-template-information-popup/group-template-information/recommended-lab-test-info/recommended-lab-test-info.component.html
// module id = ../../../../../src/app/pages/consultation/waiting-room/group-template/group-template-information-popup/group-template-information/recommended-lab-test-info/recommended-lab-test-info.component.html
// module chunks = main